import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, getDocs, query } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { EmittersService } from '../../../core/utils/emitters.service';
import { Chat } from '../interfaces/zeyo-ia';
import { ChatsIaService } from '../utils/chats-ia.service';

@Injectable({
	providedIn: 'root'
})
export class FirebaseIAService {
	settings = {
		status: '',
		firstCall: true
	};

	constructor(
		private firestore: Firestore,
		private _authenticationService: AuthenticationService,
		private _emittersService: EmittersService,
		private _chatsIaService: ChatsIaService
	) {}

	getConversations2(): void {
		this._getFirebaseResponse();
	}

	get(rute: string): Observable<any> {
		const reff = collection(this.firestore, rute);
		return collectionData(reff, { idField: 'uid' }) as Observable<any>;
	}
	getChatsById(rute: string, uid: string): Observable<any[]> {
		const chatsRef = collection(this.firestore, `${rute}/${uid}/chats`);
		return collectionData(chatsRef, { idField: 'id' }) as Observable<any[]>;
	}

	private _getFirebaseResponse(): void {
		this.getChatsById(
			environment.ia.collectionName,
			`${this._authenticationService.currentUser.user.sub}`
		).subscribe({
			next: (res) => {
				res.sort(function (a: Chat, b: Chat) {
					if (a.creationTime < b.creationTime) return -1;
					if (a.creationTime > b.creationTime) return 1;
					return 0;
				});

				if (this.settings.firstCall) {
					for (const element of res) {
						if (element.status === 'pending') {
							this.settings.status = 'pending';
							this._chatsIaService.loadings.search = true;
						}
						this._chatsIaService.processChat.push({
							message: element.question,
							how: 'me',
							configurations: {
								message: '',
								loading: 'success'
							},
							answer: '',
							showOptions: false,
							creationTime: element.creationTime,
							status: element.status
						});
						this._chatsIaService.processChat.push({
							message: element.message,
							how: 'ia',
							configurations: {
								message: '',
								loading: 'success'
							},
							answer: element.answer,
							showOptions: false,
							creationTime: element.creationTime,
							status: element.status
						});
					}
					this.settings.firstCall = false;
				} else {
					const find = res.find((res) => res.status === 'pending');
					if (!find && this._chatsIaService.loadings.search && this.settings.status === 'pending') {
						this._chatsIaService.loadings.search = false;
						this.settings.status = '';
						this._emittersService.notificationIA.emit(true);
					}
					const lastRegister = res[res.length - 1];
					if (lastRegister.status === 'completed') {
						for (const element of this._chatsIaService.processChat) {
							if (element.status === 'pending') element.status = 'completed';
						}

						this._chatsIaService.processChat.push({
							message: lastRegister.message,
							how: 'ia',
							configurations: {
								message: '',
								loading: 'success'
							},
							answer: lastRegister.answer,
							showOptions: false,
							creationTime: lastRegister.creationTime,
							status: lastRegister.status
						});
						this._emittersService.responseChatIaResponse.emit(res);
					}
				}
			},
			error: (err) => {
				console.error(err);
			}
		});
	}

	private async _getAllAIChats(rute: string, uid: string): Promise<any[]> {
		const chatsRef = collection(this.firestore, `${rute}/${uid}/chats`);
		const aiQuery = query(chatsRef);
		const snapshot = await getDocs(aiQuery);
		const data: any = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
		data.sort(function (a: Chat, b: Chat) {
			if (a.creationTime < b.creationTime) return -1;
			if (a.creationTime > b.creationTime) return 1;

			return 0;
		});
		for (const element of data) {
			if (element.status === 'pending') {
				this.settings.status = 'pending';
				this._chatsIaService.loadings.search = true;
			}
			this._chatsIaService.processChat.push({
				message: element.question,
				how: 'me',
				configurations: {
					message: '',
					loading: 'success'
				},
				answer: '',
				showOptions: false,
				creationTime: element.creationTime,
				status: element.status
			});
			this._chatsIaService.processChat.push({
				message: element.message,
				how: 'ia',
				configurations: {
					message: '',
					loading: 'success'
				},
				answer: element.answer,
				showOptions: false,
				creationTime: element.creationTime,
				status: element.status
			});
		}
		return data;
	}
}
